import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Tab } from '../../../components';
import { ArchivedTab } from './ArchivedTab';
import { CompletedTab } from './CompletedTab';
import { DraftsTab } from './DraftsTab';
import { IncompleteTab } from './IncompleteTab';
import { PendingTab } from './PendingTab';
import { ScheduledTab } from './ScheduledTab';
import * as S from './RequestsTab.styles';

export const RequestsTab = ({ group }) => {
	const [tabs, setTabs] = useState([
		{
			id: 1,
			label: 'Pending',
			component: <PendingTab group={group} />,
		},
		{
			id: 2,
			label: 'Drafts',
			component: <DraftsTab group={group} />,
		},
		{
			id: 3,
			label: 'Scheduled',
			component: <ScheduledTab group={group} />,
		},
		{
			id: 4,
			label: 'Completed',
			component: <CompletedTab group={group} />,
		},
		{
			id: 5,
			label: 'Incomplete',
			component: <IncompleteTab group={group} />,
		},
		{
			id: 6,
			label: 'Archived',
			component: <ArchivedTab group={group} />,
		},
	]);

	return (
		<S.Wrapper>
			<Tab tabs={tabs} setTabs={setTabs} transparent variation="pill" />
		</S.Wrapper>
	);
};

RequestsTab.propTypes = {
	group: PropTypes.object,
};
